import { render } from "./ProviderDataTable.vue?vue&type=template&id=6e4b80d3&scoped=true&lang=pug"
import script from "./ProviderDataTable.vue?vue&type=script&lang=js"
export * from "./ProviderDataTable.vue?vue&type=script&lang=js"

import "./ProviderDataTable.vue?vue&type=style&index=0&id=6e4b80d3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e4b80d3"]])

export default __exports__